module.exports = __webpack_public_path__ + "img/c.5cd2c50f.jpg";